// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { toValue } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CrmRelationsContactpersoonDto } from '../model/crmRelationsContactpersoonDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieAanmaken</li></ul>
 * @summary Maak een nieuwe contactpersoon aan voor een relatie
 */
export const relatieContactpersonenMaakRelatieContactPersoon = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  crmRelationsContactpersoonDto?: MaybeRefOrGetter<CrmRelationsContactpersoonDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  crmRelationsContactpersoonDto = toValue(crmRelationsContactpersoonDto);

  return customInstance<string>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsContactpersoonDto,
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenMaakRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
    TError,
    RelatieContactpersonenMaakRelatieContactPersoonMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenMaakRelatieContactPersoonMutationVariables,
  TContext
> => {
  const mutationKey = ['relatieContactpersonenMaakRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
    RelatieContactpersonenMaakRelatieContactPersoonMutationVariables
  > = (props) => {
    const { relatienummer, data } = props ?? {};

    return relatieContactpersonenMaakRelatieContactPersoon(relatienummer, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenMaakRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>
>;
export type RelatieContactpersonenMaakRelatieContactPersoonMutationBody =
  | CrmRelationsContactpersoonDto
  | undefined;
export type RelatieContactpersonenMaakRelatieContactPersoonMutationError = ErrorType<void>;
export type RelatieContactpersonenMaakRelatieContactPersoonMutationVariables = {
  relatienummer: number | undefined | null;
  data?: CrmRelationsContactpersoonDto;
};

/**
 * @summary Maak een nieuwe contactpersoon aan voor een relatie
 */
export const useRelatieContactpersonenMaakRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
      TError,
      RelatieContactpersonenMaakRelatieContactPersoonMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenMaakRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenMaakRelatieContactPersoonMutationVariables,
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenMaakRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Werkt een contactpersoon van een relatie bij
 */
export const relatieContactpersonenMuteerRelatieContactPersoon = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  contactpersoonId: MaybeRefOrGetter<string | undefined | null>,
  crmRelationsContactpersoonDto?: MaybeRefOrGetter<CrmRelationsContactpersoonDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  contactpersoonId = toValue(contactpersoonId);
  crmRelationsContactpersoonDto = toValue(crmRelationsContactpersoonDto);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen/${contactpersoonId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsContactpersoonDto,
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenMuteerRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
    TError,
    RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables,
  TContext
> => {
  const mutationKey = ['relatieContactpersonenMuteerRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
    RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables
  > = (props) => {
    const { relatienummer, contactpersoonId, data } = props ?? {};

    return relatieContactpersonenMuteerRelatieContactPersoon(
      relatienummer,
      contactpersoonId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenMuteerRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>
>;
export type RelatieContactpersonenMuteerRelatieContactPersoonMutationBody =
  | CrmRelationsContactpersoonDto
  | undefined;
export type RelatieContactpersonenMuteerRelatieContactPersoonMutationError = ErrorType<void>;
export type RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables = {
  relatienummer: number | undefined | null;
  contactpersoonId: string | undefined | null;
  data?: CrmRelationsContactpersoonDto;
};

/**
 * @summary Werkt een contactpersoon van een relatie bij
 */
export const useRelatieContactpersonenMuteerRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
      TError,
      RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenMuteerRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenMuteerRelatieContactPersoonMutationVariables,
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenMuteerRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Verwijdert een contactpersoon van een relatie
 */
export const relatieContactpersonenVerwijderRelatieContactPersoon = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  contactpersoonId: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  contactpersoonId = toValue(contactpersoonId);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/contactpersonen/${contactpersoonId}`,
      method: 'DELETE',
      signal,
    },
    options,
  );
};

export const getRelatieContactpersonenVerwijderRelatieContactPersoonMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
    TError,
    RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables,
  TContext
> => {
  const mutationKey = ['relatieContactpersonenVerwijderRelatieContactPersoon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
    RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables
  > = (props) => {
    const { relatienummer, contactpersoonId } = props ?? {};

    return relatieContactpersonenVerwijderRelatieContactPersoon(
      relatienummer,
      contactpersoonId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieContactpersonenVerwijderRelatieContactPersoonMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>
>;

export type RelatieContactpersonenVerwijderRelatieContactPersoonMutationError = ErrorType<void>;
export type RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables = {
  relatienummer: number | undefined | null;
  contactpersoonId: string | undefined | null;
};

/**
 * @summary Verwijdert een contactpersoon van een relatie
 */
export const useRelatieContactpersonenVerwijderRelatieContactPersoon = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
      TError,
      RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieContactpersonenVerwijderRelatieContactPersoon>>,
  TError,
  RelatieContactpersonenVerwijderRelatieContactPersoonMutationVariables,
  TContext
> => {
  return useMutation(
    getRelatieContactpersonenVerwijderRelatieContactPersoonMutationOptions(options),
    queryClient,
  );
};
